import * as React from 'react';

import CarouselContext from 'src/common/stores/contexts/carousel-context-provider';

import { SharedUiSimilarPropertiesWrapper, SimilarPropertiesWrapperProps } from '../shared-ui/details/shared-ui-similar-properties';
import { PropertySearchCriteriaInput, ShoppingContextInput } from 'src/common/__generated__/api';

interface PropertyRecsVariantWrapperProps {
  propertySearchCriteriaInput: PropertySearchCriteriaInput;
  propertyId: string;
  shoppingContext: ShoppingContextInput;
}

const PropertyRecsVariantWrapper: React.FC<PropertyRecsVariantWrapperProps> = ({
  propertyId,
  propertySearchCriteriaInput,
  shoppingContext,
}) => {
  const { addTopCarouselName } = React.useContext(CarouselContext);

  React.useEffect(() => addTopCarouselName('similar-properties'), []);

  const inputProps: SimilarPropertiesWrapperProps = {
    inputs: {
      propertyId,
      searchCriteria: propertySearchCriteriaInput,
      shoppingContext,
    },
  };

  return <SharedUiSimilarPropertiesWrapper inputs={inputProps.inputs} />;
};

export default PropertyRecsVariantWrapper;
